import React from 'react' ; 
import './Experience.css'

function Experience() {
  return (
    <div className="Experience component__space" id="Experience">
          <div className="heading">
                <h1 className="heading">Experience</h1>
                <p className="heading p__color">Experience is not just about what you have done, but also about what you have learned and how you have grown. </p>
            </div>
            <div>
            <div className="container">
                <div className="row">
                    <div className="col__2">
                        <div className="Experienc__box pointer">
                            <div className="icon">
                            <svg className='company' fill="#F9004D" width="64px" height="64px" viewBox="-2 0 16 16" id="company-16px" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path id="Path_133" data-name="Path 133" d="M323.5-192h-9a1.5,1.5,0,0,0-1.5,1.5V-176h12v-14.5A1.5,1.5,0,0,0,323.5-192ZM318-177v-3h2v3Zm6,0h-3v-3.5a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v3.5h-3v-13.5a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5Zm-8-12h2v2h-2Zm4,0h2v2h-2Zm-4,4h2v2h-2Zm4,0h2v2h-2Z" transform="translate(-313 192)"></path> </g></svg>
                            </div>
                            <div className="services__meta">
                                <h1 className="services__text">WeFix App | Full Stack Developer | Student job</h1>
                                <p className="p services__text p__color"> Feb 2022 - Mar 2022 | Holon, Tel Aviv, Israel</p>
                                <p className="p services__text p__color">Stack : </p>
                                <li className="p services__text p__color">Angular</li>
                                <li className="p services__text p__color">Node.js</li>
                                <li id="fake" className="p services__text p__color">MongoDB</li>
                            </div>
                        </div>
                    </div>

                    <div className="col__2">
                        <div className="Experienc__box pointer">
                            <div className="icon">
                            <svg className='company' fill="#F9004D" width="64px" height="64px" viewBox="-2 0 16 16" id="company-16px" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path id="Path_133" data-name="Path 133" d="M323.5-192h-9a1.5,1.5,0,0,0-1.5,1.5V-176h12v-14.5A1.5,1.5,0,0,0,323.5-192ZM318-177v-3h2v3Zm6,0h-3v-3.5a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5v3.5h-3v-13.5a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5Zm-8-12h2v2h-2Zm4,0h2v2h-2Zm-4,4h2v2h-2Zm4,0h2v2h-2Z" transform="translate(-313 192)"></path> </g></svg>
                            </div>
                            <div className="services__meta">
                                <h1 className="services__text">Poyechali | Full Stack Developer</h1>
                                <p className="p services__text p__color">Oct 2022 - Present | Remote</p>
                                <p className="p services__text p__color">Stack : </p>
                                <li className="p services__text p__color">React</li>
                                <li className="p services__text p__color">Firebase</li>
                                <li className="p services__text p__color">Angular </li>
                                <li id="fake" className="p services__text p__color">UI UX</li>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
            </div>
    </div>
    
  )
}

export default Experience